<template>
  <div class="crm-options scroll-container p-3">
    <form>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-group label="Funil" label-for="pipeline-input">
            <b-form-select
              id="pipeline-input"
              v-model="formData.lead_pipeline_id"
              :options="funisOptions"
              @change="onFunilChange"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione um funil</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="Estágio" label-for="stage-input">
            <b-form-select
              id="stage-input"
              v-model="formData.lead_pipeline_stage_id"
              :options="estagiosOptions"
              @change="updateJson"
              :disabled="!formData.lead_pipeline_id"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione um estágio</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="Produto" label-for="produto-input">
            <b-form-select
              id="produto-input"
              v-model="formData.product_id"
              :options="produtosOptions"
              @change="updateJson"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione um produto</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="Origem" label-for="origem-input">
            <b-form-select
              id="origem-input"
              v-model="formData.lead_source_id"
              :options="origensOptions"
              @change="updateJson"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione uma origem</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="Tipo de Lead" label-for="tipo-lead-input">
            <b-form-select
              id="tipo-lead-input"
              v-model="formData.lead_type_id"
              :options="tiposLeadOptions"
              @change="updateJson"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione um tipo</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="Usuário" label-for="usuario-input">
            <b-form-select
              id="usuario-input"
              v-model="formData.user_id"
              :options="usuariosOptions"
              @change="updateJson"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Selecione um usuário</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import ApiService from "../../core/services/api.service";

export default {
  name: "CrmOptions",
  components: {},
  data() {
    return {
      crmConfig: null,
      loading: true,
      parametrosCarregados: false,
      formData: {
        lead_pipeline_id: null,
        lead_pipeline_stage_id: null,
        lead_source_id: null,
        lead_type_id: null,
        user_id: null,
        product_id: null
      },
      formatIsValidJson: true,
      headersIsValidJson: true,
      parsedJson: null,
      estagiosOptions: []
    };
  },
  computed: {
    produtosOptions() {
      if (!this.crmConfig?.produtos) return [];
      return this.crmConfig.produtos.map((produto) => ({
        value: produto.id,
        text: produto.name
      }));
    },
    origensOptions() {
      if (!this.crmConfig?.origens) return [];
      return this.crmConfig.origens.map((origem) => ({
        value: origem.id,
        text: origem.name
      }));
    },
    funisOptions() {
      if (!this.crmConfig?.funis) return [];
      return this.crmConfig.funis.map((funil) => ({
        value: funil.id,
        text: funil.name
      }));
    },
    tiposLeadOptions() {
      if (!this.crmConfig?.tiposLead) return [];
      return this.crmConfig.tiposLead.map((tipo) => ({
        value: tipo.id,
        text: tipo.name
      }));
    },
    usuariosOptions() {
      if (!this.crmConfig?.usuarios) return [];
      return this.crmConfig.usuarios.map((usuario) => ({
        value: usuario.id,
        text: usuario.name
      }));
    }
  },
  methods: {
    onFunilChange(load = false) {
      if (!load) {
        // Limpa o estágio selecionado quando o funil muda
        this.formData.lead_pipeline_stage_id = null;
      }

      // Atualiza as opções de estágios baseado no funil selecionado
      if (this.formData.lead_pipeline_id && this.crmConfig?.funis) {
        const funilSelecionado = this.crmConfig.funis.find(
          (funil) => funil.id === this.formData.lead_pipeline_id
        );

        if (funilSelecionado?.stages) {
          this.estagiosOptions = funilSelecionado.stages.map((stage) => ({
            value: stage.id,
            text: stage.name
          }));
        } else {
          this.estagiosOptions = [];
        }
      } else {
        this.estagiosOptions = [];
      }

      this.updateJson();
    },
    updateJson() {
      this.json["CRM"] = JSON.stringify({
        ...this.salvarDados()
      });
    },
    salvarDados() {
      return {
        title: "Lead de campanha",
        lead_pipeline_id: this.formData.lead_pipeline_id,
        lead_pipeline_stage_id: this.formData.lead_pipeline_stage_id,
        lead_source_id: this.formData.lead_source_id,
        lead_type_id: this.formData.lead_type_id,
        user_id: this.formData.user_id,
        products: {
          product_0: {
            product_id: this.formData.product_id,
            name:
              this.produtosOptions.find(
                (p) => p.value === this.formData.product_id
              )?.text || "",
            quantity: 1,
            price: 0
          }
        },
        person: {
          name: "{cliente_nome}",
          email: [
            {
              value: "",
              label: "work"
            }
          ],
          contact_numbers: [
            {
              value: "{destinatario}",
              label: "work"
            }
          ]
        },
        entity_type: "leads"
      };
    },
    async preencherForm(objJson) {
      this.formData = {
        lead_pipeline_id: objJson.lead_pipeline_id || null,
        lead_pipeline_stage_id: objJson.lead_pipeline_stage_id || null,
        lead_source_id: objJson.lead_source_id || null,
        lead_type_id: objJson.lead_type_id || null,
        user_id: objJson.user_id || null,
        product_id: objJson.products?.product_0?.product_id || null
      };

      await this.pegarParametrosChatbot();

      if (this.formData.lead_pipeline_id) {
        this.onFunilChange(true);
      }
    },
    handleFocus(event) {
      this.$emit("focused", event.target.id);
    },
    async pegarParametrosChatbot() {
      try {
        const res = await ApiService.get(
          "/conta/crm/parametros-chatbot",
          "",
          true,
          {
            baseURL: process.env.VUE_APP_COMUNICANTE_API_PAINEL
          }
        );
        this.crmConfig = res.data.data;
        this.parametrosCarregados = true;
      } catch (error) {
        this.crmConfig = { funis: [] };
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    if (this.json["CRM"]) {
      const objJson = JSON.parse(this.json["CRM"]);
      this.preencherForm(objJson);
    }
  },
  props: {
    json: {
      required: true
    }
  }
};
</script>

<style scoped>
.crm-options {
  margin: 0 auto;
}
.scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 15px; /* Evita que o conteúdo fique escondido pela barra de rolagem */
}
</style>
